import React from "react";
import { Helmet } from "react-helmet";
import { Button, Card, Typography, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import CustomAppBar from "../../components/AppBar";
import { DEHAAT_LOGIN_URL } from "../../globals/const";
import { getDehaatJwt } from "../../api/thirdPartyServices";

// Glass Card styling
const GlassCard = styled(Card)(({ theme }) => ({
  background: "rgba(255, 255, 255, 0.25)",
  backdropFilter: "blur(10px)",
  borderRadius: 16,
  border: "1px solid rgba(255, 255, 255, 0.3)",
  boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
  padding: theme.spacing(3),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.spacing(2),
  margin: 3,
}));

const DehaatLogin = () => {
  const handleLogin = async () => {
    try {
      // Get location from sessionStorage
      const userLocation = JSON.parse(
        sessionStorage.getItem("userLocation") || "{}"
      );
      const lat_lng = `${userLocation.latitude},${userLocation.longitude}`;

      // Get JWT token from separate service
      const jwt = await getDehaatJwt();
      if (!jwt) {
        console.error("JWT Token is null or undefined");
        return;
      }

      // Create and submit form
      const form = document.createElement("form");
      form.method = "POST";
      form.action = DEHAAT_LOGIN_URL;
      form.style.display = "none";
      form.enctype = "application/x-www-form-urlencoded";

      const fields = { data: jwt, lat_lng, lang: "en", redirect_uri: "" };

      Object.entries(fields).forEach(([key, value]) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = value;
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    } catch (err) {
      console.error("Login failed", err);
    }
  };

  return (
    <>
      <Helmet>
        <title>DeHaat Login - Farmapp</title>
      </Helmet>
      <CustomAppBar />
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        style={{ minHeight: "50vh", my: "auto" }}
      >
        <Grid item xs={12} md={8} lg={6} my="auto">
          <GlassCard>
            <Typography variant="h5" fontWeight="bold" color="primary">
              DeHaat Partner Portal
            </Typography>

            <Typography variant="body2" color="text.secondary" align="center">
              Connect to DeHaat agriculture ecosystem for farmers
            </Typography>

            <Button
              variant="contained"
              color="success"
              onClick={handleLogin}
              sx={{
                textTransform: "none",
                px: 4,
                py: 1.5,
                borderRadius: 28,
                fontWeight: "bold",
              }}
            >
              Login with DeHaat
            </Button>
          </GlassCard>
        </Grid>
      </Grid>
    </>
  );
};

export default DehaatLogin;
